
import { apiConnector } from "./apiConnector"
import { getdata } from "./apis"

const {
    DATA_API
} =getdata

export  const getData =async(Category)=>{
    
        try{
            const response=await apiConnector("POST",DATA_API,{
                Category:Category
            })

            console.log(response)
            if (!response.data.success) {
                throw new Error(response.data.message)
            }

            return response.data.data
        } catch(error){
            console.log("error calling backend")
            console.log(error)
        }
    
}